import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { AsyncErrorHandler } from 'lib/ui';
import { GlobalAnalysisDto } from 'models/pen/GlobalAnalysis';
import { ErrorService } from 'services/error-service';
import { GlobalAnalysisService } from 'services/pen/global-analysis-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class GlobalAnalysisContainer {
  protected headers: {
    title: string;
  }[] = [];
  protected globalAnalyses: GlobalAnalysisDto[] = [];

  constructor(
    private errorService: ErrorService,
    private toast: ToastService,
    private globalAnalysisService: GlobalAnalysisService,
    private confirmDialog: ConfirmDialog,
    private t: I18N
  ) {}

  protected async attached() {
    this.createHeaders();
    await this.getGlobalAnalyses();
  }

  @AsyncErrorHandler
  private async getGlobalAnalyses() {
    this.globalAnalyses = await this.globalAnalysisService.getAll();
  }

  private async onDelete(id: number) {
    const confirmed = await this.confirmDialog.confirmDelete();
    if (!confirmed) return;
    await this.globalAnalysisService.delete(id);
    this.toast.showSuccess(this.t.tr('general.deleted'));
    await this.getGlobalAnalyses();
  }

  @AsyncErrorHandler
  private async onSave(globalAnalysisDto: GlobalAnalysisDto) {
    if (globalAnalysisDto.Id) {
      await this.globalAnalysisService.put(globalAnalysisDto, globalAnalysisDto.Id);
    } else {
      await this.globalAnalysisService.post(globalAnalysisDto);
    }
    this.toast.showSuccess(this.t.tr('general.saved'));
    globalAnalysisDto.Id ? this.editingGlobalAnalysis = undefined : this.isCreating = false;
    await this.getGlobalAnalyses();
  }

  protected isCreating = false;
  protected editingGlobalAnalysis: number | undefined = undefined;
  protected setEditingGlobalAnalysis(id: number) {
    this.isCreating = false;
    this.editingGlobalAnalysis = id;
  }

  protected setIsCreatingGlobalAnalysis(isCreating: boolean) {
    this.editingGlobalAnalysis = undefined;
    this.isCreating = isCreating;
  }

  private createHeaders() {
    this.headers = [
      { title: this.t.tr('general.analysisNo') },
      { title: this.t.tr('general.name') },
      { title: this.t.tr('mooring.version') },
      { title: this.t.tr('general.author') },
      { title: this.t.tr('general.date') },
      { title: this.t.tr('general.actions') },
    ];
  }
}